 <mat-card style="float: left;clear: both">
    <mat-toolbar>
    {{'concursos.titol' | translate }}
    <span class="fill-remaining-space"></span>
    <div style="width:100%;float:right">
      <button mat-icon-button matTooltip="{{'concursos.exportToolTip' | translate}}" attr.aria-label="{{'concursos.exportToolTip' | translate}}" 
        matTooltipClass="tooltip-style" (click)="exportar()" style="float: right; margin-right: 0">
          <mat-icon color="primary" style="font-size:24px">vertical_align_bottom</mat-icon>
      </button>
    </div> 
  </mat-toolbar>
  <mat-progress-bar mode="indeterminate" color="warm" *ngIf="showAsyncProgress" style="position: absolute;"></mat-progress-bar>
  <div style="width: 100%;height: 140px;background-color:#dee8f4;padding: 10px">

    <label style="width: 15%;height:50px;float:left;clear:none;padding-right:15px">
      <mat-select [(ngModel)]="activeFilters.estat" name="estat" ngDefaultControl placeholder="{{'concursos.colEstat' | translate}}" style="border-bottom: 1px solid gray">
         <mat-option *ngFor="let option of this.listConcursosService.valFiltres.rows['estat']"  value="{{option}}">{{option}}</mat-option>
      </mat-select>
    </label>

    <label style="width: 20%;height:50px;float:left;clear:none;padding-right:15px">
      <mat-select [(ngModel)]="activeFilters.ambit" name="ambit" ngDefaultControl placeholder="{{'concursos.colAmbit' | translate}}" style="border-bottom: 1px solid gray" multiple>
         <mat-option *ngFor="let option of this.listConcursosService.valFiltres.rows['ambit']"  value="{{option.value}}">{{option.value}}</mat-option>
      </mat-select>
    </label>

    <label style="width: 20%;height:50px;float:left;clear:none;padding-right:15px">
      <mat-select [(ngModel)]="activeFilters.pais" name="pais" ngDefaultControl placeholder="{{'concursos.colPais' | translate}}" style="border-bottom: 1px solid gray">
         <mat-option *ngFor="let option of this.listConcursosService.valFiltres.rows['pais']"  value="{{option.value}}">{{option.value}}</mat-option>
      </mat-select>
    </label>

    <label style="width: 20%;height:50px;float:left;clear:none;padding-right:15px">
      <mat-select [(ngModel)]="activeFilters.ciutat" name="ciutat" ngDefaultControl placeholder="{{'concursos.colCiutat' | translate}}" style="border-bottom: 1px solid gray">
         <mat-option *ngFor="let option of this.listConcursosService.valFiltres.rows['ciutat']"  value="{{option.value}}">{{option.value}}</mat-option>
      </mat-select>
    </label>

    <label style="width: 10%;height:50px;float:left;clear:none;padding-right:15px">
      <mat-select [(ngModel)]="activeFilters.any_signatura" name="any_signatura" ngDefaultControl placeholder="{{'concursos.colany_signatura' | translate}}" style="border-bottom: 1px solid gray">
         <mat-option *ngFor="let option of this.listConcursosService.valFiltres.rows['any_signatura']"  value="{{option.value}}">{{option.value}}</mat-option>
      </mat-select>
    </label>

    <label style="width: 10%;height:50px;float:left;clear:none;padding-right:15px">
      <mat-select [(ngModel)]="activeFilters.any_ult_factura" name="any_ult_factura" ngDefaultControl placeholder="{{'concursos.colany_factura' | translate}}" style="border-bottom: 1px solid gray">
         <mat-option *ngFor="let option of this.listConcursosService.valFiltres.rows['any_ult_factura']"  value="{{option.value}}">{{option.value}}</mat-option>
      </mat-select>
    </label>

    <label style="width: 20%;height:50px;float:left;clear:none;padding-right:15px">
      <mat-select [(ngModel)]="activeFilters.tematica" name="tematica" ngDefaultControl multiple placeholder="{{'concursos.colTematica' | translate}}" style="border-bottom: 1px solid gray">
         <mat-option *ngFor="let option of this.listConcursosService.valFiltres.rows['tematiques']"  value="{{option.value}}">{{option.value}}</mat-option>
      </mat-select>
    </label>

    <label style="width: 20%;height:50px;float:left;clear:none">
      <mat-select [ngModel]="activeFilters.grup_tematiques" name="grup_tematiques" ngDefaultControl placeholder="{{'concursos.colTematica_grup' | translate}}" style="border-bottom: 1px solid gray" (ngModelChange)="seleccionaTematiques($event)">
         <mat-option *ngFor="let option of this.listConcursosService.valFiltres.rows['grup_tematiques']" value="{{option.text}}">{{option.text}}</mat-option>
      </mat-select>
    </label>

    <mat-form-field style="height:50px;float:left;clear:left">
      <input matInput style="flex-grow: 1; flex-basis: 0"
        name="cpv" [(ngModel)]="activeFilters.cpv"
        placeholder="{{('concursos.colcpv') | translate}}" 
        ngDefaultControl/>
    </mat-form-field>

    <mat-form-field style="height:50px;float:left;clear:none;padding-left:15px">
      <input matInput style="flex-grow: 1; flex-basis: 0"
        name="ppropi" [(ngModel)]="activeFilters.ppropi"
        placeholder="{{('concursos.colPress_prop') | translate}}" 
        ngDefaultControl/>
    </mat-form-field>
    
    <mat-form-field style="float:left;clear:none;padding-left:15px">
      <input matInput style="flex-grow: 1; flex-basis: 0"
        name="pproj" [(ngModel)]="activeFilters.pproj"
        placeholder="{{('concursos.colPress_proj') | translate}}" 
        ngDefaultControl/>
    </mat-form-field>

    <div style="float:left;clear:none;padding-left:15px;padding-top:15px">
      <div style="float:left;clear:none;padding-right:5px;padding-top:2px">{{('concursos.colCertificat') | translate}}</div>
      <mat-checkbox style="margin-right: 1em" color="warn"
          [(ngModel)]="activeFilters.certificat" name="certificat"
          ngDefaultControl>
      </mat-checkbox>
    </div>

    <div style="float:left;clear:none;width:150px;padding-left:40px">
      <button matTooltip="{{'common.cerca' | translate}}" attr.aria-label="{{'common.cerca'}}" matTooltipClass="tooltip-style" mat-button (click)="this.sendActiveFilters()" style="min-width:45px;padding:10px">
             <mat-icon color="primary" style="font-size: 24px">search</mat-icon>
      </button>
      <button matTooltip="{{'common.reinicia' | translate}}" attr.aria-label="{{'common.reinicia' | translate}}" matTooltipClass="tooltip-style" mat-button (click)="resetActiveFilters()" style="min-width:45px;padding:10px">
            <mat-icon color="primary" style="font-size: 24px">autorenew</mat-icon>
      </button>
    </div>
  </div>
  <mat-card style="padding:24px;padding-top:0px;width:100%">
    <table style="width:100%">
      <thead mat-head>
        <tr>
          <th style="font-size:0.9em;width:10%;text-align: center;cursor:pointer" (click)="cycleOrdering('clau')" mat-column>{{'concursos.colNom' | translate}}
          <mat-icon style="vertical-align: middle">
              {{(
                orderingParameters['clau'] === 1 ?
                'keyboard_arrow_up' :
                  (orderingParameters['clau'] === 2 ?
                  'keyboard_arrow_down' : '')
               )}}
            </mat-icon></th>
          <th style="font-size:0.9em;width:35%;text-align: center;cursor:pointer" (click)="cycleOrdering('titol')" mat-column>{{'concursos.colTitol' | translate}}
          <mat-icon style="vertical-align: middle">
              {{(
                orderingParameters['titol'] === 1 ?
                'keyboard_arrow_up' :
                  (orderingParameters['titol'] === 2 ?
                  'keyboard_arrow_down' : '')
               )}}
            </mat-icon></th>
          <th style="font-size:0.9em;width:15%;text-align: center;cursor:pointer" (click)="cycleOrdering('empresa')" mat-column>{{'concursos.colEmpresa' | translate}}
          <mat-icon style="vertical-align: middle">
              {{(
                orderingParameters['empresa'] === 1 ?
                'keyboard_arrow_up' :
                  (orderingParameters['empresa'] === 2 ?
                  'keyboard_arrow_down' : '')
               )}}
            </mat-icon></th>
          <th style="font-size:0.9em;width:10%;text-align: center;cursor:pointer" (click)="cycleOrdering('pais')" mat-column>{{'concursos.colPais' | translate}}
          <mat-icon style="vertical-align: middle">
              {{(
                orderingParameters['pais'] === 1 ?
                'keyboard_arrow_up' :
                  (orderingParameters['pais'] === 2 ?
                  'keyboard_arrow_down' : '')
               )}}
            </mat-icon></th>
          <th style="font-size:0.9em;width:10%;text-align: center;cursor:pointer" (click)="cycleOrdering('ciutat')" mat-column>{{'concursos.colCiutat' | translate}}
          <mat-icon style="vertical-align: middle">
              {{(
                orderingParameters['ciutat'] === 1 ?
                'keyboard_arrow_up' :
                  (orderingParameters['ciutat'] === 2 ?
                  'keyboard_arrow_down' : '')
               )}}
            </mat-icon></th>
          <th style="font-size:0.9em;width:15%;text-align: center;cursor:pointer" (click)="cycleOrdering('client')" mat-column>{{'concursos.colClient' | translate}}
          <mat-icon style="vertical-align: middle">
              {{(
                orderingParameters['client'] === 1 ?
                'keyboard_arrow_up' :
                  (orderingParameters['client'] === 2 ?
                  'keyboard_arrow_down' : '')
               )}}
            </mat-icon></th>
          <th style="font-size:0.9em;width:5%;text-align: center;cursor:pointer" mat-column (click)="cycleOrdering('pproj')">{{'concursos.colPress' | translate}}
            <mat-icon style="vertical-align: middle">
              {{(
                orderingParameters['pproj'] === 1 ?
                'keyboard_arrow_up' :
                  (orderingParameters['pproj'] === 2 ?
                  'keyboard_arrow_down' : '')
               )}}
            </mat-icon>
          </th>
          <th style="font-size:0.9em;width:5%;text-align: center;cursor:pointer" mat-column (click)="cycleOrdering('ppropi')">{{'concursos.colPropi' | translate}}
            <mat-icon style="vertical-align: middle">
              {{(
                orderingParameters['ppropi'] === 1 ?
                'keyboard_arrow_up' :
                  (orderingParameters['ppropi'] === 2 ?
                  'keyboard_arrow_down' : '')
               )}}
            </mat-icon>
          </th>
          <th style="font-size:0.9em;width:5%;text-align: center;cursor:pointer" (click)="cycleOrdering('data_signatura')" mat-column>{{'concursos.colDatSign' | translate}}
          <mat-icon style="vertical-align: middle">
              {{(
                orderingParameters['data_signatura'] === 1 ?
                'keyboard_arrow_up' :
                  (orderingParameters['data_signatura'] === 2 ?
                  'keyboard_arrow_down' : '')
               )}}
            </mat-icon></th>
          <th style="font-size:0.9em;width:5%;text-align: center;cursor:pointer" (click)="cycleOrdering('data_ult_factura')" mat-column>{{'concursos.colDatUltFact' | translate}}
            <mat-icon style="vertical-align: middle">
              {{(
                orderingParameters['data_ult_factura'] === 1 ?
                'keyboard_arrow_up' :
                  (orderingParameters['data_ult_factura'] === 2 ?
                  'keyboard_arrow_down' : '')
               )}}
            </mat-icon>
          </th>
          <th style="font-size:0.9em;width:5%;text-align: center;cursor:pointer" (click)="cycleOrdering('certificat')" mat-column>{{'concursos.colCertif' | translate}}
          <mat-icon style="vertical-align: middle">
              {{(
                orderingParameters['certificat'] === 1 ?
                'keyboard_arrow_up' :
                  (orderingParameters['certificat'] === 2 ?
                  'keyboard_arrow_down' : '')
               )}}
            </mat-icon></th>
      </tr>
      </thead>
      <tbody *ngIf="concursosData">
        <tr *ngFor="let dades of concursosData; let i = index" style="cursor:pointer">
          <td style="font-size:0.9em;text-align:left">
            {{dades.clau | translate}}
          </td>
          <td style="text-align:left">
              <div *ngIf="dades.ambit=='Europa'" style='color:#0000FF;font-size:0.9em'>{{dades.titol}}</div>
              <div *ngIf="dades.ambit=='Internacional'" style='color:#008800;font-size:0.9em'>{{dades.titol}}</div>
              <div *ngIf="dades.ambit=='Catalunya'" style="color:rgb(100,100,100);font-size:0.9em">{{dades.titol}}</div>
              <div *ngIf="dades.ambit=='Espanya'" style="color:#800000;font-size:0.9em">{{dades.titol}}</div>
          </td>
          <td style="font-size:0.9em;text-align:center">{{dades.empresa}}</td>
          <td style="font-size:0.9em;text-align:center">{{dades.pais}}</td>
          <td style="font-size:0.9em;text-align:center">{{dades.ciutat}}</td>
          <td style="font-size:0.9em;text-align:center">{{dades.client}}</td>
          <td style="font-size:0.9em;text-align:center">{{dades.pproj | number: '1.2-2'}}</td>
          <td style="font-size:0.9em;text-align:center">{{dades.ppropi | number: '1.2-2'}}</td>
          <td style="font-size:0.9em;text-align:center">{{dades.data_signatura}}</td>
          <td style="font-size:0.9em;text-align:center">{{dades.data_ult_factura}}</td>
          <td style="font-size:0.9em;text-align:center">{{dades.certificat}}</td>
        </tr>
      </tbody>
    </table>
  </mat-card>
  <mat-toolbar class="footer">
    <span class="fill-remaining-space"></span>
    <span style="padding-right: 1em">
      {{'concursos.liniesPag' | translate}}: {{listConcursosService.rowsPerPage}}
      <button mat-icon-button [mat-menu-trigger-for]="menuNumberRows">
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
    </span>
    <span style="padding-right: 1em">
      {{'concursos.pagina' | translate}}:
    </span>
    <button mat-icon-button (click)="requestPrevious()">
      <mat-icon>keyboard_arrow_left</mat-icon>
    </button>
    <span style="text-align:center;width:20px">{{listConcursosService.currentPage+1}}</span>
    <button mat-icon-button (click)="requestNext()">
      <mat-icon>keyboard_arrow_right</mat-icon>
    </button>
  </mat-toolbar>
 <mat-menu #menuNumberRows y-position="above">
     <button mat-menu-item *ngFor="let value of rowsPerPageOptions" (click)="setRowPerPage(value)">{{value}}</button>
 </mat-menu>
</mat-card>
<mcrit-gestio-concursos-resume
   [dades]="resumeData"  [titol]="'Àmbit dels treballs'" style="float: left;margin-top: 20px;clear: both;width: 100%;background-color:white;margin-bottom:20px">
</mcrit-gestio-concursos-resume>